import axios from "axios";
import HttpService from "./HttpService.js";

export default class ReportsService {
    constructor() {
        this._http = new HttpService();
        this._urlBase = `${process.env.REACT_APP_DELIVERIES_API}/reports`;
    }

    async getAllDebtors() {
        const response = await this._http.get(`${this._urlBase}/all_debtors`);
        return response;
    }

    async exportWalletTransactions(startDate, endDate, userId) {
        const queryParams = new URLSearchParams();
        if (startDate) queryParams.append('startDate', startDate);
        if (endDate) queryParams.append('endDate', endDate);
        if (userId) queryParams.append('userId', userId);

        const url = `${this._urlBase}/wallet_transactions?${queryParams.toString()}`;
        const response = await axios.get(url, {
            responseType: 'blob',
        });
        return response;

    }
}
